"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = require("../../../../../../../services/config");
var _SaveToClaim = require("../../../../../../modals/SaveToClaim");
var _actions = require("../../store/actions");
var _selectors = require("./store/selectors");
var _excluded = ["hotelID", "offerID", "queryID"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var withSaveOrderButtonProps = function withSaveOrderButtonProps(Component) {
  var WithSaveOrderButtonProps = function WithSaveOrderButtonProps(_ref) {
    var _getOnSaveOfferToClai;
    var hotelID = _ref.hotelID,
      offerID = _ref.offerID,
      queryID = _ref.queryID,
      props = _objectWithoutProperties(_ref, _excluded);
    var _useTranslation = (0, _reactI18next.useTranslation)('RESULT_CARD'),
      t = _useTranslation.t;
    var dispatch = (0, _reactRedux.useDispatch)();

    // if transport is false access must be true for nakanikuly
    var haveAccessToClients = (_getOnSaveOfferToClai = (0, _config.getOnSaveOfferToClaim)()) !== null && _getOnSaveOfferToClai !== void 0 ? _getOnSaveOfferToClai : true;
    var isSavedOffer2Claim = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getIsSavedOffer2Claim)(state, {
        offerID: offerID
      });
    });
    var handleSaveTourToClaim = (0, _react.useCallback)(function () {
      return dispatch((0, _SaveToClaim.showSaveToClaimModal)({
        header: t('SAVE_TOUR_TO_CLAIM_HEADER_AT_MODAL'),
        onSave: function onSave(_ref2) {
          var claimID = _ref2.claimID,
            clientID = _ref2.clientID,
            claimIndex = _ref2.claimIndex,
            callbacks = _ref2.callbacks;
          return dispatch((0, _actions.saveOfferToClaim)(callbacks, {
            claimID: claimID,
            clientID: clientID,
            hotelID: hotelID,
            offerID: offerID,
            queryID: queryID,
            claimIndex: claimIndex
          }));
        }
      }));
    }, [dispatch, hotelID, offerID, queryID, t]);
    return haveAccessToClients && /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
      isSaved: isSavedOffer2Claim,
      onClick: handleSaveTourToClaim
    }));
  };
  WithSaveOrderButtonProps.propTypes = {
    hotelID: _propTypes.default.number.isRequired,
    offerID: _propTypes.default.string.isRequired,
    queryID: _propTypes.default.string.isRequired
  };
  return WithSaveOrderButtonProps;
};
var _default = exports.default = withSaveOrderButtonProps;